"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSnackbar = void 0;

var _react = require("react");

var _SnackbarProvider = require("./SnackbarProvider");

var useSnackbar = function useSnackbar() {
  return (0, _react.useContext)(_SnackbarProvider.SnackbarContext);
};

exports.useSnackbar = useSnackbar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTbmFja2JhciIsInVzZUNvbnRleHQiLCJTbmFja2JhckNvbnRleHQiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udGV4dHMvU25hY2tiYXIvdXNlU25hY2tiYXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgU25hY2tiYXJDb250ZXh0LCBTbmFja2JhclByb3ZpZGVyVmFsdWUgfSBmcm9tICcuL1NuYWNrYmFyUHJvdmlkZXInO1xuXG5leHBvcnQgY29uc3QgdXNlU25hY2tiYXIgPSAoKSA9PlxuICB1c2VDb250ZXh0PFNuYWNrYmFyUHJvdmlkZXJWYWx1ZT4oU25hY2tiYXJDb250ZXh0KTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBOztBQUVPLElBQU1BLFdBQVcsR0FBRyxTQUFkQSxXQUFjO0VBQUEsT0FDekIsSUFBQUMsaUJBQUEsRUFBa0NDLGlDQUFsQyxDQUR5QjtBQUFBLENBQXBCIn0=